import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Profileconnectivity from "../Profile_connectivity/profileconnectivity";
import Editdilogbox from "./Editdilogbox/editdilogbox";
import PublicIcon from "@mui/icons-material/Public";
import SchoolIcon from "@mui/icons-material/School";
import ModeIcon from "@mui/icons-material/Mode";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/esm/Button";
import Form from "react-bootstrap/Form";
import ProfileDel from "@/components/ProfileDel-modal";
import { useProfileSectionState } from "../../../../hooks/useProfileSectionState";
import "./Profilesection.css";

const Profilesection = ({
  infooo,
  setInfooo,
  id,
  onCardSelect,
  marketerFor,
}) => {
  const {
    privacyOpen,
    editbox,
    setEditbox,
    shows,
    marketerverify,
    boxOpen,
    handleClose,
    handledelete,
    inputChange,
    createShop,
    userDatahandler,
    userDatahandler1,
    userDatahandler2,
    userDatahandler3,
    userDatahandler4,
    handlePrivacyToggle,
    location,
    navigate,
  } = useProfileSectionState({ infooo, setInfooo, id });

  const getEmailString = () => {
    if (!infooo?.email) return null;
    return typeof infooo.email === "string"
      ? infooo.email
      : infooo.email?.text || null;
  };

  const obfuscateEmail = (email) => {
    if (!email) return null;
    const parts = email.split("@");
    if (parts.length !== 2) {
      return email.length > 3 ? `${email.slice(0, 3)}***` : `${email}***`;
    }
    const [local, domain] = parts;
    return `${local}${local ? "***" : ""}@${domain}`;
  };

  // Display helpers to support both legacy shapes and new normalized shapes
  const addressText =
    infooo?.address?.text ||
    infooo?.address?.street ||
    infooo?.address?.street ||
    "";

  const educationList = (infooo?.education || [])
    .map((it) => (typeof it === "string" ? it : it?.text || ""))
    .filter(Boolean);

  const contactText =
    typeof infooo?.contactNumber === "string"
      ? infooo.contactNumber
      : infooo?.contactNumber?.text || infooo?.contactNumber?.primary || "";

  const createdDate = (() => {
    if (!infooo?.createdAt) return null;
    try {
      const d = new Date(infooo.createdAt);
      return isNaN(d.getTime())
        ? String(infooo.createdAt).slice(0, 10)
        : d.toISOString().slice(0, 10);
    } catch (e) {
      return String(infooo.createdAt).slice(0, 10);
    }
  })();

  return (
    <>
      <Container>
        <ProfileDel
          shows={shows}
          handleClose={handleClose}
          handledelete={handledelete}
        />
        <Row className="align-items-stretch">
          {location.pathname === "/marketing-profile" ? (
            ""
          ) : (
            <Col
              lg="3"
              className="pe-xl-0 ps-xl-2 ps-lg-1 pe-lg-0 ps-sm-2 pe-sm-2 ps-xs-2 pe-xs-2 d-flex flex-column"
            >
              {editbox && (
                <Editdilogbox
                  setEditbox={setEditbox}
                  editbox={editbox}
                  inputChange={inputChange}
                  userDatahandler={userDatahandler}
                  userDatahandler1={userDatahandler1}
                  userDatahandler2={userDatahandler2}
                  userDatahandler3={userDatahandler3}
                  userDatahandler4={userDatahandler4}
                  createShop={createShop}
                />
              )}

              <div className="bg-white pr-0 mt-2 intro-equal-height">
                <p className="ms-2 fw-medium mt-2 mb-1 text-black" style={{fontSize: 12}}>Profile Introduction</p>
                <ListGroup className="introBox list-unstyled font_small_profile">
                  <ListGroup.Item className="d-flex justify-content-between border-0 p-1">
                    <div className="d-flex">
                      <PublicIcon className="icon_f_sm me-1" />
                      <p className="mb-0 profile_para_s">
                        {addressText ||
                          (location.pathname === "/user-profile"
                            ? "Add your address"
                            : "Not added Yet")}
                      </p>
                    </div>
                    {location.pathname === "/user-profile" && (
                      <div>
                        <ModeIcon
                          className="icon_f_sm"
                          onClick={() => setEditbox(1)}
                        />
                      </div>
                    )}
                  </ListGroup.Item>
                  <div className="d-flex flex-column mt">
                    <ListGroup.Item className="border-0 p-1">
                      {educationList && educationList.length > 0 ? (
                        educationList.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between"
                          >
                            <div className="d-flex">
                              <SchoolIcon className="icon_f_sm me-1" />
                              <p className="mb-0 profile_para_s">
                                {item ||
                                  (location.pathname === "/user-profile"
                                    ? "Add your education"
                                    : "Not added Yet")}
                              </p>
                            </div>
                            {location.pathname === "/user-profile" && (
                              <div>
                                <ModeIcon
                                  className="icon_f_sm"
                                  onClick={() => setEditbox(2)}
                                />
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <SchoolIcon className="icon_f_sm me-1" />
                            <p className="mb-0 profile_para_s">
                              {location.pathname === "/user-profile"
                                ? "Add your education"
                                : "Not added Yet"}
                            </p>
                          </div>
                          {location.pathname === "/user-profile" && (
                            <div>
                              <ModeIcon
                                className="icon_f_sm"
                                onClick={() => setEditbox(2)}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </ListGroup.Item>
                  </div>
                  <ListGroup.Item className="d-flex justify-content-between border-0 p-1">
                    <div className="d-flex">
                      <CallIcon className="icon_f_sm me-1" />
                      <p className="mb-0 profile_para_s">
                        {contactText ||
                          (location.pathname === "/user-profile"
                            ? "Add your contact number"
                            : "Not added Yet")}
                      </p>
                    </div>
                    {location.pathname === "/user-profile" && (
                      <div>
                        <ModeIcon
                          className="icon_f_sm"
                          onClick={() => setEditbox(3)}
                        />
                      </div>
                    )}
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between border-0 p-1">
                    <div className="d-flex">
                      <EmailIcon className="icon_f_sm me-1" />
                      <p className="mb-0 profile_para_s">
                        {getEmailString()
                          ? obfuscateEmail(getEmailString())
                          : location.pathname === "/user-profile"
                            ? "Add your email"
                            : "Not added Yet"}
                      </p>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between border-0 p-1">
                    <div>
                      <WatchLaterIcon className="icon_f_sm me-1" />
                      {createdDate
                        ? createdDate
                        : location.pathname === "/user-profile"
                          ? "Add your joining date"
                          : "Not added Yet"}
                    </div>
                  </ListGroup.Item>
                </ListGroup>

                {location.pathname === "/user-profile" && (
                  <Col xl="10" lg="10" md="5" sm="5" className="mx-auto col-8">
                    <Button
                      onClick={() =>
                        marketerverify === false
                          ? navigate("/marketing-dashboard")
                          : navigate("/our-marketing-partner")
                      }
                      type="button"
                      className="btn text-center pt-1 pb-1 btn-primary font_small_profile mt-2 w-100"
                    >
                      Join as Our Marketer
                    </Button>
                    <Button
                      onClick={() => navigate("/CV-Form")}
                      type="button"
                      className="btn text-center pt-1 pb-1 btn-primary font_small_profile mt-2 w-100"
                    >
                      Update Cv
                    </Button>
                    <Button
                      onClick={() => navigate("/post-single-ad")}
                      type="button"
                      className="btn text-center pt-1 pb-1 btn-primary font_small_profile mt-1 w-100"
                    >
                      Single Item Ads
                    </Button>
                    {/* <Button
                      type="button"
                      className="btn text-center pt-1 pb-1 btn-primary font_small_profile mt-1 w-100"
                      onClick={() => navigate("/wallet-profile")}
                    >
                      Investment Profile
                    </Button>
                    <Button
                      type="button"
                      className="btn text-center pt-1 pb-1 btn-primary font_small_profile mt-1 w-100"
                      onClick={() => navigate("/invest-form")}
                    >
                      Invest with selectezi
                    </Button> */}
                  </Col>
                )}
              </div>

              {location.pathname === "/user-profile" && (
                <Col
                  lg="12"
                  className="ps-0 pe-0 mt-2 mb-3 privacySettings bg-white"
                >
                  <div className="d-flex justify-content-md-between">
                    <div>
                      <h6 className="ps-1 privacyText">Privacy Settings</h6>
                    </div>
                    <div className="ms-4 cursor-pointer" onClick={boxOpen}>
                      <ArrowDropDownIcon className="icon_f" />
                    </div>
                  </div>

                  {privacyOpen && (
                    <div className="p-2 noscroll">
                      <Form>
                        <div className="mb-3 font_small_profile">
                          <div className="d-flex justify-content-between align-items-center">
                            <Form.Label className="mb-0">
                              Hide / UnHide Connections
                            </Form.Label>
                            <Form.Check
                              type="switch"
                              id="default-switch"
                              name="hideConnections"
                              checked={infooo?.hideConnections || false}
                              onChange={(e) =>
                                handlePrivacyToggle(e.target.checked)
                              }
                            />
                          </div>
                        </div>
                      </Form>
                    </div>
                  )}
                </Col>
              )}
            </Col>
          )}
          <Col
            lg={location.pathname === "/marketing-profile" ? 12 : 9}
            className="pe-2 ps-1 pe-md-0 ps-md-0 pe-lg-0 ps-lg-0 pe-xl-0 ps-xl-0 pe-sm-2 ps-sm-1 d-flex flex-column"
          >
            <Profileconnectivity
              id={id}
              onCardSelect={onCardSelect}
              marketerFor={marketerFor}
              isMarketerProfile={location.pathname === "/marketing-profile"}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profilesection;
